import { Button, withStyles } from '@material-ui/core';

export const ModelWhiteButton = withStyles({
  root: {
    color: 'rgba(255,255,255,0)',
  },
  label: {
    '&$disabled': {
      color: '#707070 !important',
    },
  },
})(Button);
